import {Action} from '@ngrx/store';
import * as _ from 'lodash';

import {impersonableUsersActionTypes, LoadImpersonableUsersSuccessAction} from '../actions/impersonable-users';
import {userContextActionTypes} from '../actions/user-context';
import {ImpersonableUserVM} from '../models/impersonable-user.vm';

export interface ImpersonableUsersState {
  array: ImpersonableUserVM[];
}

const initialState: ImpersonableUsersState = {
  array: []
};

export function impersonableUsersReducer(state: ImpersonableUsersState = initialState, action: Action): ImpersonableUsersState {
  switch (action.type) {
    case impersonableUsersActionTypes.LOAD:
    case impersonableUsersActionTypes.RELOAD:
      return handleLoadAction();
    case impersonableUsersActionTypes.LOAD_SUCCESS:
      return handlerLoadSuccessAction(state, action);
    case impersonableUsersActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case userContextActionTypes.CHANGE_CLIENT:
      return handleChangeClientAction();
    default:
      return state;
  }
}

function handleLoadAction(): ImpersonableUsersState {
  return initialState;
}

function handlerLoadSuccessAction(state: ImpersonableUsersState, action: LoadImpersonableUsersSuccessAction): ImpersonableUsersState {
  const newState: ImpersonableUsersState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ImpersonableUsersState): ImpersonableUsersState {
  const newState: ImpersonableUsersState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleChangeClientAction(): ImpersonableUsersState {
  return { array: [] };
}

export const impersonableUsersSelectors = {
  array: (state: ImpersonableUsersState) => _.get(state, 'array', [])
};
